import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  catalogApiRef,
  entityPresentationApiRef,
} from '@backstage/plugin-catalog-react';
import { DefaultEntityPresentationApi } from '@backstage/plugin-catalog';
import AccountTreeIcon from '@material-ui/icons/AccountTree';

const entityPresentationApi = ApiBlueprint.make({
  name: 'entity-presentation',
  params: define =>
    define({
      api: entityPresentationApiRef,
      deps: { catalogApi: catalogApiRef },
      factory: ({ catalogApi }) =>
        DefaultEntityPresentationApi.create({
          catalogApi,
          kindIcons: { repository: AccountTreeIcon },
        }),
    }),
});

export const entityPresentationModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [entityPresentationApi],
});
